import Constants from '@usas/ui-web/utils/Constants';
import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getEvaluationLevelData from './GetEvaluationLevelData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  options: [],
  officialPositionTypeId: ''
};

const EvaluationLevelData = {
  INITIAL_STATE, getEvaluationLevelData
}

export default EvaluationLevelData;